import store from './index'

import { Snack } from '@/interfaces/snack'
import { PageMsgInterface } from '@/interfaces/page'
import { User } from '@/modules/User/interfaces/user'
import { RecordType } from '@/modules/RecordType/interfaces/record-type'
import { PhaseCases } from '@/modules/Case/interfaces/case'
import { PhaseCases as NewPhaseCases } from '@/modules/Newcase/interfaces/case'

export const dispatchShowSnack = (msg: Snack) => {
  return store.dispatch('snacks/showSnack', msg)
}

export const dispatchSignIn = (me: User) => {
  return store.dispatch('user/signIn', me)
}

export const dispatchSignOut = () => {
  return store.dispatch('user/signOut')
}

export const dispatchSetIsFold = (val: boolean) => {
  return store.dispatch('app/setIsFold', val)
}

export const dispatchUpdateRecordTypes = (val: RecordType[]) => {
  return store.dispatch('recordType/updateRecordTypes', val)
}

export const dispatchSetIsLoading = (val: boolean) => {
  return store.dispatch('app/setIsLoading', val)
}

export const dispatchPushCases = (val: PhaseCases) => {
  return store.dispatch('theCase/pushCases', val)
}

export const dispatchUpdateCases = (val: PhaseCases) => {
  return store.dispatch('theCase/updateCases', val)
}

export const dispatchPushNewCases = (val: NewPhaseCases) => {
  return store.dispatch('theCase/pushNewCases', val)
}

export const dispatchUpdateNewCases = (val: NewPhaseCases) => {
  return store.dispatch('theCase/updateNewCases', val)
}

export const dispatchStorePage = (page: PageMsgInterface) => {
  return store.dispatch('page/storePage', page)
}

export const dispatchClearPage = (routeName: string) => {
  return store.dispatch('page/clearPage', routeName)
}

export const dispatchChangeAppDrawerLayout = (val: string) => {
  return store.dispatch('app/changeAppDrawerLayout', val)
}

export const dispatchUpdatePActive = (val: number) => {
  return store.dispatch('app/updatePActive', val)
}

export const dispatchUpdateSActive = (val: number) => {
  return store.dispatch('app/updateSActive', val)
}
